import React from 'react'
import Navbar from '../Navbar/Navbar'

function Header() {
  return (
    <div>
      <Navbar/>
      </div>
  )
}

export default Header
